import { QUALIFICATIONS_CATEGORIES } from '../constants/qualification-categories';
import { CriteriaQuota } from '../interfaces/feasibility.interface';
import { Criteria, RangeSet } from '../interfaces/qualification.interface';
import { QuotaPayload } from '../interfaces/quota.interface';
import { Quotas } from '../interfaces/survey.interface';

export class Common {
  static isMultiNestedQuotasAvailable(
    quotas: (Quotas | QuotaPayload)[]
  ): boolean {
    return (
      new Set(
        quotas
          .filter(
            (quota) =>
              quota.criteria.length > 1 ||
              quota.quota_category === QUALIFICATIONS_CATEGORIES.NESTED
          )
          .map((quota) => quota.group_key)
      ).size > 1
    );
  }

  static isInvalidRangeForFeasibility(quotas: CriteriaQuota[][]): boolean {
    const isRangeSetInvalid = (rangeSet: RangeSet) =>
      rangeSet?.from > rangeSet?.to;

    const isCriteriaInvalid = (criteria: Criteria) =>
      criteria.range_sets?.[0] && isRangeSetInvalid(criteria.range_sets[0]);

    const isQuotaInvalid = (quota: CriteriaQuota[]) =>
      quota.some((q) => q.criteria.some(isCriteriaInvalid));

    const isRangeInvalid = quotas.some((quota) => isQuotaInvalid(quota));
    return isRangeInvalid;
  }
}
